module.exports = "<div class=\"g-admin-card-header\">\n  <ng-content></ng-content>\n</div>"